import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Users/hooks/useShiftGeoLocationHistory.ts
function useShiftGeoLocationHistory({ fromDate, toDate, userId }, opts = {}) {
	const fire = typeof opts.fire === "boolean" ? opts.fire : true;
	const enabled = !!userId && !!fromDate && !!toDate;
	const { call, data, isCalling } = useRPC(RPCs.Users.GetUserGeoLocationHistory.v1, enabled ? {
		fromDate,
		pagination: { limit: 2e3 },
		toDate,
		userId
	} : void 0, {
		cacheStrategy: opts.cacheStrategy,
		fire: enabled && fire
	});
	return {
		data: data?.userGeoLocationHistory,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useShiftGeoLocationHistory };

//# sourceMappingURL=useShiftGeoLocationHistory.js.map